export type BrowserApiSupport = {
  localStorage: boolean;
  sessionStorage: boolean;
  indexedDB: boolean;
  cookies: boolean;
};

export const detectBrowserApis = (): BrowserApiSupport => {
  if (typeof window === 'undefined') {
    return {
      localStorage: false,
      sessionStorage: false,
      indexedDB: false,
      cookies: false
    };
  }

  const testStorage = (storage: Storage | null): boolean => {
    if (!storage) return false;

    try {
      const testKey = '__sentry_test__';
      storage.setItem(testKey, 'test');
      storage.getItem(testKey);
      storage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  };

  const testIndexedDB = (): boolean => {
    if (!window.indexedDB) return false;

    try {
      const request = window.indexedDB.open('__sentry_test_db__', 1);
      request.onerror = () => {};
      request.onsuccess = () => {
        request.result.close();
      };
      return true;
    } catch (e) {
      return false;
    }
  };

  const testCookies = (): boolean => {
    try {
      document.cookie = '__sentry_test__=test; path=/';
      const hasCookie = document.cookie.indexOf('__sentry_test__=') !== -1;
      document.cookie =
        '__sentry_test__=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      return hasCookie;
    } catch (e) {
      return false;
    }
  };

  return {
    localStorage: testStorage(window.localStorage),
    sessionStorage: testStorage(window.sessionStorage),
    indexedDB: testIndexedDB(),
    cookies: testCookies()
  };
};
